import React from 'react';
import { Link as RebassLink } from 'rebass';

const Link = props => <RebassLink {...props} />;

export default Link;
